export const travelTranslations = {
  // 旅游相关翻译
  "travelGuide": {
    en: "Travel Guide",
    zh: "旅游指南"
  },
  "travelGuideTitle": {
    en: "Penang Travel Guide",
    zh: "槟城旅游指南"
  },
  "travelGuideDesc": {
    en: "Explore the Pearl of the Orient with our comprehensive travel guide",
    zh: "跟随我们全面的旅游指南探索东方明珠"
  },
  "discoverTopAttractions": {
    en: "Discover the top attractions, experiences, and hidden gems of Malaysia's island paradise",
    zh: "探索马来西亚岛屿天堂的顶级景点、体验和隐藏的宝藏"
  },
  "customTourPackages": {
    en: "Custom Tour Packages",
    zh: "定制旅游套餐"
  },
  "penangInADay": {
    en: "Penang in a Day",
    zh: "一日游槟城"
  },
  "culturalImmersion": {
    en: "Cultural Immersion",
    zh: "文化沉浸"
  },
  "culinaryAdventure": {
    en: "Culinary Adventure",
    zh: "美食冒险"
  },
  "islandExploration": {
    en: "Island Exploration",
    zh: "岛屿探索"
  },
  "natureAndWildlife": {
    en: "Nature & Wildlife",
    zh: "自然与野生动物"
  },
  "topAttractions": {
    en: "Top Attractions",
    zh: "热门景点"
  },
  "topAttractionsDescription": {
    en: "From UNESCO heritage sites to pristine beaches and culinary adventures, Penang offers unforgettable experiences for every traveler.",
    zh: "从联合国教科文组织遗产地到原始海滩和美食冒险，槟城为每位旅行者提供难忘的体验。"
  },
  "culturalExperiences": {
    en: "Cultural Experiences",
    zh: "文化体验"
  },
  "culturalExperiencesDescription": {
    en: "Immerse yourself in Penang's rich multicultural heritage through these authentic local experiences.",
    zh: "通过这些真实的本地体验，沉浸在槟城丰富的多元文化遗产中。"
  },
  "peranakan": {
    en: "Peranakan Heritage",
    zh: "娘惹文化遗产"
  },
  "peranakanDesc": {
    en: "Discover the unique Straits Chinese culture through museums, architecture, and culinary experiences.",
    zh: "通过博物馆、建筑和美食体验，探索独特的海峡华人文化。"
  },
  "traditionalCrafts": {
    en: "Traditional Crafts",
    zh: "传统工艺"
  },
  "traditionalCraftsDesc": {
    en: "Learn batik painting, traditional puppet making, and other local crafts from skilled artisans.",
    zh: "向熟练的工匠学习蜡染画、传统木偶制作和其他本地工艺。"
  },
  "culturalPerformances": {
    en: "Cultural Performances",
    zh: "文化表演"
  },
  "culturalPerformancesDesc": {
    en: "Experience traditional Malay, Chinese, and Indian performances showcasing the island's diverse heritage.",
    zh: "体验展示岛上多元文化遗产的传统马来、中国和印度表演。"
  },
  "festivalCalendar": {
    en: "Festival Calendar",
    zh: "节日日历"
  },
  "festivalCalendarDesc": {
    en: "Plan your visit around Penang's vibrant cultural and religious festivals throughout the year.",
    zh: "围绕槟城全年丰富多彩的文化和宗教节日计划您的行程。"
  },
  "essentialTravelTips": {
    en: "Essential Travel Tips",
    zh: "必备旅行贴士"
  },
  "bestTimeToVisit": {
    en: "Best Time to Visit",
    zh: "最佳访问时间"
  },
  "bestTimeToVisitDescription": {
    en: "Penang enjoys a tropical climate year-round. November to January may see more rainfall, while February to April offers sunny days ideal for beach activities.",
    zh: "槟城全年享有热带气候。11月至1月可能会有更多降雨，而2月至4月则阳光明媚，非常适合海滩活动。"
  },
  "gettingAround": {
    en: "Getting Around",
    zh: "出行方式"
  },
  "gettingAroundDescription": {
    en: "Public buses, ride-sharing apps, and rental bicycles are excellent options for exploring the island. The free CAT shuttle bus is perfect for Georgetown.",
    zh: "公共巴士、网约车应用和租赁自行车是探索岛屿的绝佳选择。免费的CAT穿梭巴士非常适合在乔治城游览。"
  },
  "localEtiquette": {
    en: "Local Etiquette",
    zh: "当地礼仪"
  },
  "localEtiquetteDescription": {
    en: "Respect religious sites by dressing modestly. Remove shoes when entering temples and mosques. Ask permission before photographing locals.",
    zh: "参观宗教场所时着装得体以示尊重。进入寺庙和清真寺时请脱鞋。拍摄当地人照片前请征得同意。"
  },
  "safety": {
    en: "Safety",
    zh: "安全"
  },
  "safetyDescription": {
    en: "Penang is generally safe for tourists. Stay hydrated in the tropical heat and be aware of your belongings in crowded areas as you would in any tourist destination.",
    zh: "槟城对游客来说通常是安全的。在热带炎热气候中保持水分充足，在人多的地方注意您的财物，就像在任何旅游目的地一样。"
  },
  "readyToExperiencePenang": {
    en: "Ready to Experience Penang?",
    zh: "准备好体验槟城了吗？"
  },
  "letUsHelpYouPlan": {
    en: "Let us help you plan the perfect itinerary tailored to your interests and travel style.",
    zh: "让我们帮助您规划根据您的兴趣和旅行风格量身定制的完美行程。"
  },
  "planYourTrip": {
    en: "Plan Your Trip",
    zh: "规划您的行程"
  },
  "downloadTravelGuide": {
    en: "Download Travel Guide",
    zh: "下载旅游指南"
  },
  "discoverPenang": {
    en: "Discover Penang",
    zh: "探索槟城"
  },
  "explorePenang": {
    en: "Explore the cultural diversity, natural beauty, and rich heritage of Malaysia's most charming island",
    zh: "探索马来西亚最迷人岛屿的文化多样性、自然美景和丰富遗产"
  },
  "penangHill": {
    en: "Penang Hill",
    zh: "槟城山"
  },
  "penangHillDescription": {
    en: "Take a scenic funicular railway ride up Penang Hill for panoramic views of Georgetown and the mainland.",
    zh: "乘坐风景优美的缆车上槟城山，欣赏乔治城和大陆的全景。"
  },
  "georgetownHeritage": {
    en: "Georgetown Heritage",
    zh: "乔治城文化遗产"
  },
  "georgetownDescription": {
    en: "Explore the UNESCO World Heritage Site with its colorful street art, colonial architecture, and rich cultural history.",
    zh: "探索联合国教科文组织世界遗产地，欣赏其丰富多彩的街头艺术、殖民地建筑和丰富的文化历史。"
  },
  "kekLokSiTemple": {
    en: "Kek Lok Si Temple",
    zh: "极乐寺"
  },
  "kekLokSiDescription": {
    en: "Visit Malaysia's largest Buddhist temple complex with its impressive seven-story pagoda and bronze statue of Guanyin.",
    zh: "参观马来西亚最大的佛教寺庙建筑群，欣赏其令人印象深刻的七层宝塔和观音铜像。"
  },
  "batuFerringhiBeach": {
    en: "Batu Ferringhi Beach",
    zh: "峇都丁宜海滩"
  },
  "batuFerringhiBeachDescription": {
    en: "Relax on the pristine beaches of Batu Ferringhi or enjoy thrilling water sports and beachside dining.",
    zh: "在峇都丁宜原始海滩上放松，或享受刺激的水上运动和海边用餐。"
  },
  "penangFoodTour": {
    en: "Penang Food Tour",
    zh: "槟城美食之旅"
  },
  "penangFoodTourDescription": {
    en: "Sample the island's famous street food from Char Koay Teow to Assam Laksa at the hawker centers of Gurney Drive.",
    zh: "在格尼道的小贩中心品尝岛上著名的街头美食，从炒粿条到亚参叻沙。"
  },
  "tropicalSpiceGarden": {
    en: "Tropical Spice Garden",
    zh: "热带香料花园"
  },
  "tropicalSpiceGardenDescription": {
    en: "Wander through lush gardens showcasing over 500 varieties of exotic flora and spices native to the region.",
    zh: "漫步在郁郁葱葱的花园中，展示超过500种当地特有的异国植物和香料。"
  },
  "penangLandscapeAlt": {
    en: "Penang Landscape",
    zh: "槟城风光"
  }
};
